class FetchSubjectDirectory {
	constructor(
		public readonly accountId: number,
		public readonly facilityId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchSubjectDirectory;
